import { Controller } from "@hotwired/stimulus"

// Phase 2.6 Tier 1 — Risk Register list filter chips.
// Auto-submits the enclosing form when any chip / select changes so
// the user gets immediate filter feedback without clicking Apply.
export default class extends Controller {
  submit(event) {
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }
}
